import React, { memo, useContext, useEffect, useState, useCallback } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

import Button from '@mui/material/Button';

import PopupMenu from '../popupmenu';
import DataContext from '../../data/data-context';
// import { useWhatChangedEffect } from '../../libraries/withwhyrender';

const useStyles = makeStyles(theme => ({
    root: {
    },
    popperOverride: {
        backgroundColor: theme.palette.background.selectionAlt,
        '&::hover': {
            backgroundColor: theme.palette.background.selectionAlt,
        },
    },
    textButton: {
        borderRadius: 4,
        width: 163,
        fontSize: 14,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        textAlign: 'left',
        display: 'inline-block',
    },
}));

function BTJobSelector ({ value, onChange, componentclass, style }) {
    const classes = useStyles();
    const { backtestingJobsLite: backtestingJobs } = useContext(DataContext);
    const [jobs, setJobs] = useState([]);
    const [selection, setSelection] = useState('');

    useEffect(() => {
        setJobs(Object.entries(backtestingJobs || {})
            .map(([k, v]) => v)
            .sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
    }, [backtestingJobs]);

    useEffect(() => {
        setSelection(current => {
            const ret = current || (jobs.length ? jobs[0].uuid : undefined);
            return ret;
        });
        if (jobs.length && !value) onChange({ target: { value: jobs[0].uuid } });
    }, [value, jobs]);

    const handleOnChange = useCallback(v => {
        if (!backtestingJobs) return;
        if (!v) return;
        // select the first one on the list of no match
        if (backtestingJobs[v.uuid]) {
            setSelection(v.uuid);
            onChange({ target: { value: v.uuid } });
        } else {
            setSelection(v);
        }
    }, [backtestingJobs, onChange]);

    return (backtestingJobs
        ? <PopupMenu
            tooltip="select sensor"
            className={classes.popperOverride}
            items={jobs}
            selection={selection}
            itemkey='uuid'
            itemTitle='name'
            onSelect={handleOnChange}
            button={
                <Button
                    style={{ textAlign: 'left', ...style }}
                    className={clsx(classes.textButton, componentclass)}
                    tooltip="select sensor"
                    aria-label="select sensor">
                    {backtestingJobs[value]
                        ? (backtestingJobs[value].name || backtestingJobs[value].host)
                        : value
                    }
                </Button>
            }
            size='small'
            placement={'bottom-end'}
            zIndex={1500}/> : null
    );
}

BTJobSelector.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    componentclass: PropTypes.string,
    style: PropTypes.object
};

export default memo(BTJobSelector);
